import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import PickupDialog from '../Dispatch/RouteExecution/Pickups/PickupInfoPopup/PickupDialog';
import { getDataWithQueryString } from '../../../api/componentAPIs';
import { withSnackbar } from 'notistack';

const ShowPickupInfoPopup = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const pickupNumber = props.pickupNumber;
  const [pickupInfo, setPickupInfo] = useState(null);
  useEffect(() => {
    const fetchPickupInfo = async () => {
      try {
        if (location.state?.pickupInfo) {
          setPickupInfo(location.state.pickupInfo);
        } else {
          const response = await getDataWithQueryString(
            'GetReportingPickupDetails',
            `pickupNumber=${pickupNumber}`
          );
          if (response?.status >= 200 && response?.status < 400) {
            if (response.data) {
              setPickupInfo(response.data);
            } else {
              handleError({ message: `Data not available for pickup : ${pickupNumber}` });
            }
          } else {
            handleError(response);
          }
        }
      } catch (error) {
        handleError({});
      }
    };

    if (pickupNumber) {
      fetchPickupInfo();
    }
  }, [pickupNumber]);

  const handleError = (response) => {
    const errorMessage = response?.response?.data?.error?.message || response?.message;
    props.enqueueSnackbar(errorMessage || 'An error occurred while fetching pickup details', {
      variant: 'error'
    });
    handleClose();
  };

  const handleClose = () => {
    setPickupInfo(null);
    navigate(location.pathname, { replace: true });
  };

  return pickupNumber && pickupInfo ? (
    <PickupDialog
      pickInfoStateData={{
        ...location.state,
        pickupInfo
      }}
      handleClose={handleClose}
    />
  ) : null;
};

export default withSnackbar(ShowPickupInfoPopup);
